<template>
  <div id="markdown-editor">
    <!-- start text editor component -->
    <div class="panel panel-default" data-sortable-id="ui-widget-8">
      <div class="panel-toolbar">
        <div class="btn-group m-r-5">
          <a class="btn btn-white" href="javascript:;">Markdown</a>
          <a class="btn btn-white" href="javascript:;" @click="preview">Preview</a>
          <app-fileupload v-on:uploaded="imageUploaded($event)" :context="context"></app-fileupload>
          <app-podbean-explorer v-on:selected="itemSelected($event)"></app-podbean-explorer>
        </div>
      </div>
      <textarea class="form-control no-rounded-corner" :rows="rows" v-model="content" :readOnly="readOnly"></textarea>
    </div>
    <!-- end of text editor component -->

    <app-modal v-if="showModal" v-on:ok="showModal = false">
      <h4 slot="header">Markdown Preview</h4>
      <div slot="body" v-html="compiledContent" ref="test"></div>
    </app-modal>
  </div>
</template>

<script>
import FileUpload from '@/components/plugins/FileUpload'
import PodbeanExplorer from '@/components/plugins/PodbeanExplorer'
import Modal from '@/components/plugins/Modal'
import Marked from 'marked'

export default {
  name: 'markdown-editor',
  components: {
    'app-modal': Modal,
    'app-fileupload': FileUpload,
    'app-podbean-explorer': PodbeanExplorer
  },
  props: ['rows', 'readOnly', 'value', 'context'],
  data: function () {
    return {
      math: null,
      compiledContent: '',
      showModal: false,
      content: ''
    }
  },
  methods: {
    preview: function () {
      var text =  this.compileInlineLatex(this.content)
      text = this.compileBlockLatex(text)
      text = Marked(text, { sanitize: false })

      this.compiledContent = text
      this.showModal = true
    },
    compileInlineLatex: function(content) {
      var pattern = /\\\\\((.*?)\\\\\)/g
      var compiledContent = content
      var match
      while(match = pattern.exec(compiledContent)) {
        var index = match.index
        var length = match[0].length
        var formula = katex.renderToString(match[1])
        compiledContent = compiledContent.substr(0, index) + formula + compiledContent.substr(index + length)
      }

      return compiledContent
    },
    compileBlockLatex: function(content) {
      var pattern = /\$\$(.*?)\$\$/g
      var compiledContent = content
      var match
      while(match = pattern.exec(compiledContent)) {
        var index = match.index
        var length = match[0].length
        var formula = '<p class="text-center">' + katex.renderToString(match[1]) + '</p>'
        compiledContent = compiledContent.substr(0, index) + formula + compiledContent.substr(index + length)
      }

      return compiledContent
    },
    imageUploaded: function (url) {
      this.content += '\n![Alt](' + url + ')'
    },
    itemSelected: function (content) {
      this.content += content
    }
  },
  watch: {
    'content': function(input) {
      this.$emit('content-updated', input)
    },
    'value': function(val) {
      this.content = this.value
    }
  },
  mounted: function() {
    this.content = this.value
  }
}
</script>



// WEBPACK FOOTER //
// MarkdownEditor.vue?4bb9ee5a